import { getStrings } from '../../../Common/Localization/commonStrings';

const localizedStrings = {
  TwoFactorAuthentication:{
    strings:{
      en:{
        verify:'Verify',
        verifyEmail:'Verify this email',
        verifyPhone:'Verify this number',
        VerifyYourEmailAddress:'Verify Your Email Address',
        VerifyYourPhoneAddress:'Verify Your Phone Number',
        VerifyYourEmailAddressSubText:'We will send a verification code that you’ll need to enter on the next screen. ',
        VerifyYourPhoneNumberSubText:'Choose how you want to receive this code.',
        emailVerified:'Your Email Address has been verified.',
        phoneVerified:'Your phone number has been verified.',
        enterVerificationCodeReceived:'Enter the 6-digit verification code you received from us.',
        enterVerificationCodeReceivedPhone:'Enter the 6-digit verification code you received from us and select your phone type.',
        enterVerificationCode:'Enter Verification Code',
        verificationCode:'Verification Code',
        resendCode:'Resend code',
        codeResent:'Code resent',
        phonetype:'Phone Type',
        mobile:'Mobile',
        landline:'Landline',
        textMe:'Text Me',
        callMe:'Call Me',
        ok:'Ok',
        limitExceedErrorMsg: 'You have temporarily exceeded the resend-code limit. Please try again in 30 minutes.',
        // verifyEmailLabel:'Verify Your Email Address',
        // verifyPhoneLabel:'Verify Your Phone Number',
        // textMe:'Text Me',
        // callMe:'Call Me',
        // emailMe:'Email me',
         back:'Back',
        // sendMe:'Send Me',
         sendCode:'Send Code',
         verifyEmailTxt:"We will send you an email message with a verification code that you’ll need to enter on the next screen.",
        // verifyPhnTxt:"We will send a verification code that you’ll need to enter on the next screen. Choose how you want to receive this code.",
         verifyTextNumber:"We will send you a text message with a verification code that you’ll need to enter on the next screen.",
         verifyVoiceNumber:"We will send you a voice call with a verification code that you’ll need to enter on the next screen.",           
        // enterVerifyCode:"Enter Verification Code",
         emailVerification:"Enter your 6-digit verification code below.",
         textVerification:"Enter your 6-digit verification code below.",
         callVerification:"Enter your 5-digit verification code below.",
        // phoneType:"Phone Type",
        // mobile:"Mobile",
        // landline:"Landline",
        // verify:"Verify",
        // resend:'Resend Code',
        // VerificationCode:"Verification Code",
        // emailVerified:"Your email has been verified",
        // phoneVerified:"Your phone number has been verified",
        // ok:"Ok",
        RESEND_ERROR_MESSAGE: 'SMSALREADYSENT',
        SUCCESS: 'success',
        invalidCodeError:"The code is invalid or expired. Request a new code below.",
        tryAgain:"We were unable to resend your code. Please try again in 1 minute.",
        // resendLimitError:"You have temporarily exceeded the resend-code limit. Please try again in 30 minutes.",
      },
      es:{

      }
    },
    common:['globalError', 'cancel']
  },
};
export const getLocalizedStringstwo = (componentName) => {
  app.logger.getLogger().debug("Comp Name" + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
};